import { render, staticRenderFns } from "./ImagesTab.vue?vue&type=template&id=608ea606&"
import script from "./ImagesTab.vue?vue&type=script&lang=ts&"
export * from "./ImagesTab.vue?vue&type=script&lang=ts&"
import style0 from "./images-tab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports